import { render, staticRenderFns } from "./entrancePage.vue?vue&type=template&id=5744c83e&"
import script from "./entrancePage.vue?vue&type=script&lang=js&"
export * from "./entrancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports